/** @type import('vue').PluginObject<never> */
export const BusPlugin = {
  install(Vue) {
    Vue.prototype.$bus = new Vue()
  }
}
